var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudiocallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2645 17.032C19.3943 16.9456 19.5436 16.893 19.6989 16.8789C19.8542 16.8648 20.0106 16.8896 20.1539 16.9512L25.6805 19.4273C25.8667 19.507 26.0222 19.6447 26.1236 19.8201C26.225 19.9954 26.2669 20.1989 26.243 20.4C26.0609 21.7606 25.3909 23.0088 24.3575 23.9124C23.3241 24.816 21.9977 25.3136 20.625 25.3125C16.3981 25.3125 12.3443 23.6334 9.35549 20.6445C6.36663 17.6557 4.6875 13.6019 4.6875 9.375C4.68645 8.00227 5.184 6.67588 6.08761 5.6425C6.99123 4.60913 8.2394 3.9391 9.6 3.75704C9.80113 3.73314 10.0046 3.77503 10.1799 3.87643C10.3553 3.97783 10.4931 4.13329 10.5727 4.31954L13.0488 9.85079C13.1097 9.99285 13.1344 10.1478 13.1209 10.3017C13.1075 10.4557 13.0561 10.6039 12.9715 10.7332L10.4672 13.7109C10.3784 13.845 10.3258 13.9998 10.3147 14.1602C10.3036 14.3206 10.3344 14.4812 10.4039 14.6262C11.373 16.6102 13.4238 18.6363 15.4137 19.5961C15.5594 19.6653 15.7207 19.6954 15.8816 19.6832C16.0425 19.6711 16.1975 19.6173 16.3313 19.527L19.2645 17.032Z",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiocallIcon);
export default __webpack_public_path__ + "static/media/audiocall-icon.49c6ebbe9ccf2e9501b54d4f2537d62e.svg";
export { ForwardRef as ReactComponent };